'use strict';

import UserApi from '@api/users';
import objToFormData from "@helpers/objToFormData";
import HelperDate from "@helpers/dates";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[app::services::user::events]';

const getEvents = async (companyId, userId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventIndex(companyId, userId);
    return response.data;
}


const showEvent = async (companyId, userId, eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventShow(companyId, userId, eventId);
    return parseDataForShow(response.data);
}

const storeEvent = async(companyId, userId, event) => {
    LoggerBus.$log.debug(loggerFormat);
    const headers = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    if (event.reminders != null){
        event.reminders.forEach(element => {
        element.value = parseInt(element.value,10).toString();
        });
    }

    const formData = objToFormData(event);
    const response = await UserApi.eventStore(companyId, userId, formData, headers);
    return response.data;
}

const updateEvent = async (companyId, userId, event) =>{
    LoggerBus.$log.debug(loggerFormat);
    const headers = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    event.reminders.forEach(element => {
        element.value = parseInt(element.value,10).toString();
    });

    const formData = objToFormData(event);
    formData.append('_method', 'PUT');
    const response = await UserApi.eventUpdate(companyId, userId, event.id, formData, headers);
    return parseDataForShow(response.data);
}

const parseDataForShow = (event) => {
    event.expiry_at = HelperDate.formatDate(event.expiry_at);
    event.issued_at = HelperDate.formatDate(event.issued_at);
    event.reminders.forEach(reminder => {
        reminder.value = reminder.value.toString();
    });
    // LoggerBus.$log.debug(loggerFormat, event);
    return event;
}

const activateEvent = async (companyId, userId, eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventActivate(companyId, userId, eventId);
    return response.data;
}

const deactivateEvent = async (companyId, userId, eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventDeactivate(companyId, userId, eventId);
    return response.data;
}

const deleteEvent = async (companyId, userId, eventId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventDestroy(companyId, userId,eventId);
    return response.data;
}

const deleteFile = async (companyId, userId, eventId, fileId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventDestroyFile(companyId, userId, eventId, fileId);
    return response.data;
}

const downloadFile = async (companyId, userId, eventId, fileId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.eventDownloadFile(companyId, userId, eventId, fileId);
    return response;
}

const getTraineeEvent = async (companyId, userId) => {
    LoggerBus.$log.debug(loggerFormat);
    const response = await UserApi.getTraineeEvent(companyId, userId);
    return response;
}

export default {
    getEvents,
    storeEvent,
    showEvent,
    updateEvent,
    activateEvent,
    deactivateEvent,
    deleteEvent,
    deleteFile,
    downloadFile,
    getTraineeEvent
};